<template lang="html">
  <div id="reg-vets" class="row">
    <Header />
    <div class="col-sm-12 reg-vets">

      <div class="row filter-vets">
        <h3 class="text-center">{{translation.doctor.regVtes}}</h3>
        <form @submit.prevent="" novalidate>
          <div class="col-md-4">
            <div class="form-group">
              <div class="row">
                <div class="col-md-5">
                  <span class="search-names">{{translation.updateProfile.country}}:</span>
                </div>
                <div class="col-md-7">
                  <select v-model="doctorSearch.country" @change="countrySelected">
                    <option v-for="country in clinicsCountry" :value="country.doctorCountry">{{country.doctorCountry}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="row">
                <div class="col-md-5">
                  <span class="search-names">{{translation.updateProfile.city}}:</span>
                </div>
                <div class="col-md-7">
                  <select v-model="doctorSearch.city" :disabled='cityBolean'  @change="citySelected">
                    <option v-for="city in clinicsCity" :value="city.doctorCity">{{city.doctorCity}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="row">
                <div class="col-md-5">
                  <span class="search-names">{{translation.updateProfile.neighborhood}}:</span>
                </div>
                <div class="col-md-7">
                  <select v-model="doctorSearch.neighborhood" :disabled='neighborhoodBolean' @change="neighborhoodSelected">
                    <option v-for="neighborhood in clinicsNeighborhood" :value="neighborhood.doctorNeighborhood">{{neighborhood.doctorNeighborhood}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-12" v-if='doctors.length'>
            <div class="row">
              <div class="col-md-6 col-lg-6" v-for="doctor in doctors">
                <div class="row doctor-card">
                  <div class="col-lg-4" >
                    <span class="doctorThumb" v-if="doctor.doctorThumb">
                      <img class="img-circle img-fluid img-responsive" v-bind:src="doctor.doctorThumb" :alt="translation.profile.altImage +doctor.doctorFirstName">
                    </span>
                    <span class="doctorThumb" v-else>
                      <img class="img-circle img-fluid img-responsive" src="../assets/img/icons/vet-icon.svg" alt="Default Image">
                    </span>
                  </div>
                  <div class="col-lg-8  text-center">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="doctorName">
                          {{translation.registration.doctor + ': ' + translation.petReview.addByDoctor + ' '  + translation.profile.space  + doctor.doctorLastName}}
                        </div>
                        <div class="doctorAdress">
                          <span>{{translation.profile.address}}: </span><span v-if="doctor.doctorCountry && doctor.doctorCountry != 'null'">{{doctor.doctorCountry}}</span> <span v-if="doctor.doctorCity && doctor.doctorCity != 'null'">,{{' ' + doctor.doctorCity}}</span><span v-if="doctor.doctorNeighborhood && doctor.doctorNeighborhood != 'null'"> ,{{' ' + doctor.doctorNeighborhood}}</span>
                        </div>
                        <div>
                          <span>{{translation.registration.clinic}}: </span><span v-if="doctor.clinicName">{{doctor.clinicName}}</span>
                        </div>
                        <div class="text-dots">
                          <span>{{translation.registration.email}}: </span><span v-if="doctor.doctorEmail">{{doctor.doctorEmail}}</span>
                        </div>
                        <div class="text-dots">
                          <span>{{translation.registration.website}}: </span><span v-if="doctor.clinicWebsite"><a :href="doctor.clinicWebsite" target="_blank">{{doctor.clinicWebsite}}</a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Cookies/>
    <div class="col-sm-12 no-padding">
      <div class="home-footer">
        <HomeFooter/>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import HomeFooter from '../components/HomeFooter.vue'
import Cookies from '../components/Cookies.vue'
export default {
  data(){
    return {
      translation: message,
      clinicsCountry: [],
      clinicsCity: [],
      isSelected: false,
      cityBolean: true,
      neighborhoodBolean: true,
      clinicsNeighborhood: [],
      doctorSearch:{
        country: '',
        city: '',
        neighborhood:'',
        email: '',
        clinic: ''
      },
      doctors:[]
    }
  },
  components: {
    Header,
    HomeFooter,
    Cookies
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    var self = this;
    axios.get('search-vets-page')
    .then(function(response){
      self.noResult = false;
      self.clinicsCountry = response.data.result;
    })
    .catch(err => err)
    this.translation = window.message;
    this.getDoctors();
  },
  methods:{
    countrySelected: function(e){
      var self = this;
      var formData = this.toFormData({country:this.doctorSearch.country})
      axios.post('search-vets-country',formData)
      .then(function(response){
        self.noResult = false;
        self.clinicsCity = response.data.result;
      })
      .catch(err => err)
      this.cityBolean = false;
      this.doctorSearch.city = "";
      this.doctorSearch.neighborhood = "";
      this.filterSearch(this.doctorSearch)
    },
    citySelected: function(e){
      var self = this;
      var formData = this.toFormData({city:this.doctorSearch.city})
      axios.post('search-vets-city',formData)
      .then(function(response){
        self.noResult = false;
        self.clinicsNeighborhood = response.data.result;
      })
      .catch(err => err)
      this.neighborhoodBolean = false;
      this.doctorSearch.neighborhood = "";
      this.filterSearch(this.doctorSearch)
    },
    neighborhoodSelected: function(e){
      this.filterSearch(this.doctorSearch)
    },
    getDoctors(){
      var self = this;
      axios.get('registered-vets')
      .then(function(response){
        self.doctors = response.data.result;
      })
      .catch(err => err)
      this.cityBolean = false;
    },
    filterSearch(){
      this.loader = true;
      var formData = this.toFormData(this.doctorSearch);
      var self = this;
      axios.post('search-doctors', formData)
      .then(function(response){
        self.loader = false;
        self.noResult = false;
        self.doctors = response.data.result;

      })
      .catch(err => err)
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style lang="css" scoped>
  #reg-vets{
    background: #fff;
  }
  #reg-vets .doctorName{
    margin-top: 1em;
  }
  #reg-vets .col-md-6:nth-of-type(3),
  #reg-vets .col-lg-6:nth-of-type(3){
    clear: both;
  }
  .reg-vets{
    min-height: 100%;
    background: #fff;
  }
  .reg-vets .filter-vets select{
    color: #fff!important;
    background: none!important;
    border: none!important;
    border-radius: 0!important;
    outline: none!important;
    border-bottom: 2px solid #fff!important;
    width: 100%;
    outline: none!important;
    box-shadow: none;
  }
  .reg-vets h3 {
    color: #fff;
  }
  .reg-vets .filter-vets{
    background: #FE7154;
    padding: 2em;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    margin-bottom: 7em;
  }
  .reg-vets .filter-vets option{
    color: #000;
  }
  .no-padding {
    padding: 0;
  }
  .reg-vets .search-names{
    color: #fff;
  }
  .reg-vets .home-footer{
    margin-top: 200px;
  }
  .reg-vets div{
      word-wrap: break-word;
  }
  .reg-vets .doctor-card{
    margin-bottom: 2em;
    background-color: #84AE53;
    padding: 1em;
    color: #fff;
    border-radius: 2em;
    min-height: 20em;
  }
  .reg-vets .doctor-card a{
    font-weight: bold;
  }
  .reg-vets .doctorThumb{
    display: inline-block;
    border-radius: 50%;
    border: 2px solid #fff;
  }
  @media (max-width: 1354px) {
    .reg-vets .doctor-card{
      min-height: 25em;
    }
  }
</style>
